import { API } from '@Providers';

// TODO - AF-545 Missing interface
export default async function (payload: any) {
  const endpoint = '/api/shelter/animal-intake/add-person-to-cart';

  return API({ endpoint, method: 'post', payload });
}
